<template>
  <span class="tag">
    <slot/>
    <button v-if="canDelete"
      @click="$emit('delete')"
      class="delete"
      :class="deleteButtonClass"/>
  </span>
</template>

<script>
export default {

  props: {
    canDelete: {
      type: Boolean,
      default: false,
    },
    deleteButtonClass: {
      type: Array | Object | String,
      default: () => (['is-small'])
    }
  }

}
</script>
